import iconSet from "@sass/selection.json";
import IcomoonReact from "icomoon-react";
import React from "react";

interface IcomoonIconProps {
  icon: string;
  size?: number | string;
  color?: string;
  title?: string;
  className?: string;
  iconClassName?: string;
  onClick?: (event: React.MouseEvent<HTMLSpanElement>) => void;
  style?: React.CSSProperties;
  role?: string;
}

/** https://www.npmjs.com/package/icomoon-react */
const IcomoonIcon: React.FC<IcomoonIconProps> = ({
  icon,
  size = 16,
  color = "currentcolor",
  title,
  className = "",
  iconClassName,
  onClick,
  style,
  role,
}) => {
  return (
    <span
      onClick={onClick}
      title={title}
      className={className}
      style={style}
      role={role}
    >
      <IcomoonReact
        iconSet={iconSet}
        color={color}
        size={size}
        icon={icon}
        className={iconClassName}
        style={{ marginTop: -1, position: "unset" }}
      />
    </span>
  );
};

export default IcomoonIcon;
